// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import {
  TREE,
  FILTERS_BRANCH,
} from '../../../hfty-soil-jobs-dom/src/constants'

export default (traverse([TREE, FILTERS_BRANCH]): Selector$)
